import { Pipe, PipeTransform } from "@angular/core";
import { ClientData } from "../../providers/client";
import { Observable } from 'rxjs/Observable';

@Pipe({
  name: "formById"
})
export class FormPipe implements PipeTransform {
  constructor(
    private clientData: ClientData
  ) { }

  transform(idForm: string = null, idClient: string): Observable<any> {
    if (idForm) {
      return this.clientData.getClientFormUser(idClient, idForm);
    } else {
      return Observable.empty();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/form/form.ts